<div class="cp-drawer-body">
  <form #recordableNotificationForm="ngForm" name="recordableNotificationForm">
    <div>
      <div class="pb-3 pt-3">
        <label class="pr-2 label-alignment"><strong>Communities</strong></label>
        <p-toggleswitch name="switch" [(ngModel)]="isSwitchOn" [disabled]="((notificationRecordableViewModel.selectedCommunities | hasValue) || allCommChbx) || (notificationRecordableViewModel.selectedSubGroup)" />
        <label class="pl-2 pr-3 label-alignment"><strong>Subgroups</strong></label>
      </div>
      @if (isSwitchOn) {
        <div class="pb-3">
          <div class="row col-12">
            <label><strong>Subgroups </strong></label>
          </div>
          <div class="row col-12">
            <p-select [options]="subGroupOptions" optionLabel="subGroupName"
              [(ngModel)]="notificationRecordableViewModel.selectedSubGroup" name="subGroup"
              placeholder="Select a Subgroup"
              [showClear]="true"
              (onChange)="onHandleSubGroupChange()" />
          </div>
          @if (notificationRecordableViewModel.selectedSubGroup) {
            <div class="row col-xl-12">
              <p-listbox fluid [options]="subGroupCommunityOptions" name="commList" multiple="multiple"
                checkbox="checkbox" filter="true" placeholder="Select Community(s)"
                [listStyle]="{'max-height':'250px', 'width':'350px'}" class="pt-3" [showToggleAll]="true"
                [disabled]="(notificationRecordableViewModel.selectedSubGroup && notificationRecordableViewModel.selectedSubGroup.subGroupID > 0) || (allCommChbx && !(notificationRecordableViewModel.selectedCommunities| hasValue))">
                <ng-template let-comm #comm>
                  {{comm.orgName}} - ({{comm.sourceKey}})
                </ng-template>
              </p-listbox>
            </div>
          }
        </div>
      }
      <div class="pb-2">
        <b>{{errorMessage}}</b>
      </div>
      @if (!isSwitchOn) {
        <div class="pb-3">
          <label><strong>Communities</strong></label>
          <div class="row col-12">
            <p-checkbox class="ml-4 pb-2" name="allComm" label="Notifications for ALL Communities"
              [(ngModel)]="allCommChbx" binary="true" (onChange)="onHandleCommChbxChange($event)"
              [disabled]="(notificationRecordableViewModel.selectedSubGroup && notificationRecordableViewModel.selectedSubGroup.subGroupID > 0)" />
          </div>
          <p-listbox fluid [options]="communityOptions" name="commList"
            [(ngModel)]="notificationRecordableViewModel.selectedCommunities" multiple="multiple"
            checkbox="checkbox" filter="true" placeholder="Select Community(s)"
            [listStyle]="{'max-height':'250px'}" class="pt-1" [showToggleAll]="true"
            (onChange)="onHandleCommChange($event)"
            [disabled]="(notificationRecordableViewModel.selectedSubGroup && notificationRecordableViewModel.selectedSubGroup.subGroupID > 0) || (allCommChbx && !(notificationRecordableViewModel.selectedCommunities| hasValue))">
            <ng-template let-comm #comm>
              {{comm.orgName}} - ({{comm.sourceKey}})
            </ng-template>
            <p-footer>
              @if (notificationRecordableViewModel.selectedCommunities?.length <= 5) {
                <div class="listbox-footer-selections">
                  @for (comm of notificationRecordableViewModel.selectedCommunities; track comm; let i = $index) {
                    <span>
                      {{comm.orgName}}({{comm.sourceKey}}){{i + 1 !==
                      notificationRecordableViewModel.selectedCommunities.length ? ', '
                      :''}}
                    </span>
                  }
                </div>
              }
              @if (notificationRecordableViewModel.selectedCommunities?.length > 5) {
                <div>
                  <span>{{notificationRecordableViewModel.selectedCommunities.length}} Communities
                  selected.</span>
                </div>
              }
            </p-footer>
          </p-listbox>
        </div>
      }
      <div>
        <div class="row col-12">
          <label><strong>Recordable Category </strong></label>
        </div>
        <div class="row col-12">
          <p-checkbox class="ml-4 pb-2" name="allCat" label="Notifications for ALL Categories" binary="true"
            [(ngModel)]="allCatChbx" (onChange)="onHandleCatChbxChange($event)" />
        </div>
        <p-multiSelect fluid name="catList" [options]="categoryOptions" optionLabel="categoryName"
          [(ngModel)]="notificationRecordableViewModel.selectedCategories"
          [disabled]="allCatChbx && !(notificationRecordableViewModel.selectedCategories | hasValue)" />
      </div>
      <div>
        <div class="row col-12">
          <label><strong>Owner</strong></label>
        </div>
        <div class="row col-12">
          <p-checkbox class="ml-4 pb-2" name="allOwners" label="Notifications for ALL Owners" binary="true"
            [(ngModel)]="allOwnerChbx" (onChange)="onHandleOwnerChbxChange($event)" />
        </div>
        <p-multiSelect fluid name="ownersList" [options]="ownerOptions"
          [(ngModel)]="notificationRecordableViewModel.selectedOwners" optionLabel="displayName"
          [disabled]="allOwnerChbx && !(notificationRecordableViewModel.selectedOwners | hasValue)" />
      </div>
    </div>
  </form>
</div>

<div class="cp-drawer-footer">
  <!--#region SideBar Buttons  -->
  <pcp-commandbar>
    <command-button button-left [text]="ButtonText.Close" [iconClasses]="['fas fa-window-close']"
      (commandClick)="onClose()" [enabled]="!recordableNotificationForm.form.dirty" />
    <command-button button-right [text]="ButtonText.Save" [iconClasses]="['fas fa-check']"
      [enabled]="recordableNotificationForm.form.dirty" (commandClick)="onSave()" />
    <command-button button-right [text]="ButtonText.Cancel" [iconClasses]="['fas fa-undo']"
      [enabled]="recordableNotificationForm.form.dirty" (commandClick)="onCancel()" />
  </pcp-commandbar>
  <!--#endregion -->
</div>
